import React, { Component } from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard';

const affiliateCodeStyle = {
    "clear": "both",
    "width": "100%",
    "textAlign": "left",
}
class StudentAffiliateCode extends Component {
    constructor(props) {
        super(props);
        this.affiliateCode = props.code;

        // optional className prop
        this.classNames = "";
        if(props.className) this.classNames = props.className;

        // optional link
        this.includeLink = false;
        this.linkClickHandler = false;
        if(props.includeLink && props.linkClickHandler !== false) 
        {
            this.includeLink = props.includeLink;
            this.linkClickHandler = props.linkClickHandler
        }
    }
    componentWillUpdate(props) {
        this.affiliateCode = props.code;
    }
    render() {
        var affiliateLinkUrl = window.location.protocol + "//" + window.location.host;
        affiliateLinkUrl += "/ref/" + this.affiliateCode;
        return(<div className={this.classNames} style={affiliateCodeStyle}>
            Send this referral link to your friends to earn editing credit: <br />
                <input style={{'width': '290px'}}type="text" readOnly="readonly" value={affiliateLinkUrl} width="80"/>
                <div>
                  <CopyToClipboard text={affiliateLinkUrl}>
                  <button style={{"marginTop": "5px"}}>Copy Link</button>
                  </CopyToClipboard>
                </div>
                {(this.includeLink)?
                <a onClick={this.linkClickHandler}>Click here for more info</a>: <div></div>}
        </div>)
    }
}
export default StudentAffiliateCode;



// WEBPACK FOOTER //
// ./src/components/dashboards/StudentAffiliateCode.js